<template>
  <c-step
    stepperGrpCd="IIM_ACCIDENT_STEP_CD"
    :currentStepCd="currentStepCd"
    :param="param"
    :contentHeight="contentHeight"
    :isApprovePop="false"
    v-model="stepCd"
    @currentStep="currentStep"
    @closePopup="closePopup"
    @stepClick="stepClick"
   >
  </c-step>
</template>

<script>
export default {
  name: 'process-accident-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        count: 0,
        sysApprovalRequestId: '',
        isApprovalPop: false,
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      stepCd: '',
      currentStepCd: '',
      authUpdateData: {
        title: '사고',
        flag: false,
      }
    };
  },
  computed: {
    param() {
      let _param = {};
      _param = this.popupParam
      
      // this.$_.extend(_param, this.popupParam)
      this.$set(_param, 'isApprovePop', false)
      this.$set(_param, 'updateBtnProps', this.updateBtnProps)
      return _param
    },
    updateBtnProps() {
      return {
        data: this.authUpdateData,
        flagCondition: this.popupParam.stepCd !== 'ISPC000005' && Boolean(!this.popupParam.sysApprovalRequestId),
        btnEditable: this.editable 
          && this.popupParam.stepCd === 'ISPC000005' 
          && Boolean(this.popupParam.iimAccidentId)
      }
    },
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;

      // url setting
      this.popupParam.isApprovalPop = false;
      // code setting
      // list setting
      this.setStep();
    },
    setStep() {
      if (!this.popupParam.stepCd || this.popupParam.stepCd === 'ISPC000001') {
        this.stepCd = 'IASC000001'
        this.currentStepCd = 'IASC000001'
      } else if (this.popupParam.stepCd === 'ISPC000002') {
        this.stepCd = 'IASC000005'
        this.currentStepCd = 'IASC000010'
      } else if (this.popupParam.stepCd === 'ISPC000003') {
        this.stepCd = 'IASC000005'
        this.currentStepCd = 'IASC000010'
      } else if (this.popupParam.stepCd === 'ISPC000004') {
        this.stepCd = 'IASC000010'
        this.currentStepCd = 'IASC000010'
      } else {
        this.stepCd = 'IASC000015'
        this.currentStepCd = 'IASC000015'
      }
    },
    currentStep(step) {
      if (!step || step === 'ISPC000001') {
        this.stepCd = 'IASC000001'
        this.currentStepCd = 'IASC000001'
      } else if (step === 'ISPC000002') {
        this.stepCd = 'IASC000005'
        this.currentStepCd = 'IASC000010'
      } else if (step === 'ISPC000003') {
        this.stepCd = 'IASC000005'
        this.currentStepCd = 'IASC000010'
      } else if (step === 'ISPC000004') {
        this.stepCd = 'IASC000010'
        this.currentStepCd = 'IASC000010'
      } else {
        this.stepCd = 'IASC000015'
        this.currentStepCd = 'IASC000015'
      }
      this.popupParam.stepCd = step;
    },
    closePopup() {
      this.$emit('closePopup')
    },
    stepClick() {
      this.popupParam.count++;
    },
  }
};
</script>
